import {Link} from "react-router-dom";

import instagramLogo from "../../images/instagram.svg";
import batensVerdenHeleNorge from "../../images/batens-verden_hele_norge.svg";
import facebookIcon from "../../images/icons/facebook.svg";
import bannerImage2 from "../../images/banner-image2.webp"
import advertService from "../../services/AdvertService";
import c from "./Banner1.module.scss";

export default function Banner1({noBannerList, isBannerVisible, bannerRef, logoUrl}) {
	let visible = true;
	if (noBannerList&&noBannerList.indexOf(window.location.toString().split('/')[3]) > -1) {
		visible = false;
	}

	if (!visible) return null;
	return <>
	<div ref={bannerRef} className={[c.banner1, isBannerVisible ? c.banner1Hidden : ''].join(' ')}>
		<div className={c.part1Container}>
			<div className={c.part1}>
				<Link to={'https://abo.b-v.no/25_04/?kilde=bv%20nett'} target={"_blank"} className={c['part1-1']}><img src={bannerImage2}/></Link>
				<div className={c['part1-2']}>
					<a href={"https://abo.b-v.no/25_04/?kilde=bv%20nett"} target="_blank" rel="noreferrer">Abonner nå</a>
					<a href={"https://abo.b-v.no/kontakt"} target="_blank" rel="noreferrer">Tips oss</a>
				</div>
			</div>
		</div>
		<Link className={c.part2} to={logoUrl?logoUrl:'/'}><img className={c.part2} src={batensVerdenHeleNorge} alt='Båtens verden logo'/></Link>
		<div className={c.part3}>
			<div className={c['part3-1']}>
				<a href={"https://instagram.com/batensverden/"} target="_blank" rel="noreferrer" style={{
					backgroundImage: `url("${instagramLogo}")`
				}}></a>
				<a href={"https://www.facebook.com/batensverden/"} target="_blank" rel="noreferrer" style={{
					backgroundImage: `url(${facebookIcon})`
				}}></a>
			</div>
		</div>
	</div></>
}